// EditProduct.js
import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { useFirestore } from "../../firebase/FirestoreContext";
import config from "../../../config";
import EditProductForm from "./EditProductForm";
import ComplianceTab from "./ComplianceTab";
import ImageUpload from "./ImageUpload";
import ReviewsTab from "./ReviewsTab";
import ProductCoaTab from "./ProductCoaTab";
import StaffReview from "./StaffReview";
import { EnvContext } from "../../../context/EnvContext";
import { doc, updateDoc } from "firebase/firestore";

const EditProduct = () => {
  const environment = useContext(EnvContext);
  const db = useFirestore();
  const { id } = useParams();
  const navigate = useNavigate();
  const collectionPath = environment === "staging" ? config.enveironment.staging.collectionPath : config.enveironment.production.collectionPath;

  // Shared state for editing a product
  const [productData, setProductData] = useState({});
  const [brands, setBrands] = useState([]);
  const [dosingGuides, setDosingGuides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState("form");
  const [selectedCompliance, setSelectedCompliance] = useState([]);

  // Fetch product data and related information (brands, dosing guides, etc.)
  useEffect(() => {
    if (id) {
      // Fetch product by id (using your Firestore logic)
      // Example:
      // const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
      // getDoc(productDocRef).then((docSnap) => { if (docSnap.exists()) setProductData(docSnap.data()); });
    }
    // Fetch brands and dosing guides here...
  }, [id, db, collectionPath]);

  const saveCompliance = async () => {
    setLoading(true);
    try {
      const productDocRef = doc(db, `${collectionPath}Products/ProductsList/DataBase`, id);
      await updateDoc(productDocRef, {
        compliance: selectedCompliance,
        compliance_type: "custom",
      });
      toast.success("Compliance saved successfully!"); // Success toast
    } catch (error) {
      console.error("Error saving compliance:", error);
      toast.error("Failed to save compliance."); // Error toast
    } finally {
      setLoading(false);
    }
  };

  const renderTab = () => {
    switch (currentTab) {
      case "form":
        return (
          <EditProductForm
            db={db}
            id={id}
            productData={productData}
            setProductData={setProductData}
            brands={brands}
            dosingGuides={dosingGuides}
            collectionPath={collectionPath}
            loading={loading}
            setLoading={setLoading}
          />
        );
      case "compliance":
        return (
          <ComplianceTab
            db={db}
            id={id}
            productData={productData}
            setProductData={setProductData}
            collectionPath={collectionPath}
            loading={loading}
            setLoading={setLoading}
            selectedCompliance={selectedCompliance}
            setSelectedCompliance={setSelectedCompliance}
            saveCompliance={saveCompliance}
          />
        );
      case "images":
        return (
          <ImageUpload
            db={db}
            id={id}
            productData={productData}
            setProductData={setProductData}
            collectionPath={collectionPath}
            loading={loading}
            setLoading={setLoading}
          />
        );
      case "reviews":
        return <ReviewsTab db={db} id={id} collectionPath={collectionPath} />;
      case "coa":
        return <ProductCoaTab />;
      case "staf_review":
        return <StaffReview />;
      default:
        return null;
    }
  };

  return (
    <div style={styles.container}>
      <ToastContainer position="top-center" autoClose={5000} />
      <h2>Edit Product {productData.product_name && `: ${productData.product_name}`}</h2>
      <div style={styles.tabHeader}>
        <button style={currentTab === "form" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("form")}>
          Edit Product Data
        </button>
        <button style={currentTab === "compliance" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("compliance")}>
          Compliance
        </button>
        <button style={currentTab === "images" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("images")}>
          Edit Product Images
        </button>
        <button style={currentTab === "reviews" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("reviews")}>
          Reviews
        </button>
        <button style={currentTab === "coa" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("coa")}>
          COA
        </button>
        <button style={currentTab === "staf_review" ? styles.activeTabButton : styles.tabButton} onClick={() => setCurrentTab("staf_review")}>
          Staff Review
        </button>
      </div>
      {renderTab()}
    </div>
  );
};

const styles = {
  container: {
    padding: 20,
  },
  tabHeader: {
    display: "flex",
    justifyContent: "flex-start",
    marginLeft: 20,
  },
  tabButton: {
    padding: 10,
    backgroundColor: "#d5d4d4",
    color: "gray",
    marginRight: 5,
    borderRadius: "5px 5px 0 0",
    fontSize: 12,
    border: "none",
    cursor: "pointer",
  },
  activeTabButton: {
    padding: 10,
    backgroundColor: "#ff0000",
    color: "white",
    marginRight: 5,
    borderRadius: "5px 5px 0 0",
    fontSize: 12,
    border: "none",
    cursor: "pointer",
  },
  deleteButton: {
    padding: "10px 20px",
    backgroundColor: "red",
    color: "white",
    border: "none",
    borderRadius: 5,
    cursor: "pointer",
  },
};

export default EditProduct;
